import type { Environment } from '@change-corgi/config/environments';

import { googleSignInClientIds } from './data';

export function getGoogleSignInClientId(environment: Environment): string {
	// eslint-disable-next-line security/detect-object-injection
	return googleSignInClientIds[environment];
}
